export default function VideoPreview({ url, type }) {
  return (
    <video controls>
      <source src={url} type={type} />

      <style jsx>{`
        video {
          max-width: 30rem;
          max-height: 30rem;
          border-radius: 1rem;
        }
      `}</style>
    </video>
  )
}
